export const OPERATOR_QUERY_PARAM_KEY = 'filter_operator_ids';
